/*
 * @Author: chenkailun
 * @Date: 2024-03-20 13:11:46
 * @LastEditors: chenkailun
 * @LastEditTime: 2024-10-18 16:32:46
 * @Description:
 * @FilePath: \solarbiolite\src\api\consignee.js
 */
import { fetchEndpoint } from '../server/network'

// 收货人列表
export const consigneeList = () => fetchEndpoint('/v2/ecapi.consignee.list', 'POST', {})

// 添加收货人
export const consigneeAdd = (country, address, consignee, email, area_code, tel, zip_code) =>
	fetchEndpoint('/v2/ecapi.consignee.add', 'POST', {
		country: country, // 国家
		address: address, // 地址
		consignee: consignee, // 收件人
		email: email, // 邮箱
		area_code: area_code, // 区号
		tel: tel, //电话
		zip_code: zip_code	//邮编
	})

// 删除收货人
export const consigneeDelete = consignee =>
	fetchEndpoint('/v2/ecapi.consignee.delete', 'POST', {
		consignee: consignee
	})

// 修改收货人
export const consigneeUpdate = (consigneeId, country, address, consignee, email, area_code, tel, zip_code) =>
	fetchEndpoint('/v2/ecapi.consignee.update', 'POST', {
		consigneeId: consigneeId,
		country: country, // 国家
		address: address, // 地址
		consignee: consignee, // 收件人
		email: email, // 邮箱
		area_code: area_code, // 区号
		tel: tel, //电话
		zip_code: zip_code	//邮编
	})

// 设置默认地址 ECM4.0
export const consigneeSetdefault = consignee =>
	fetchEndpoint('/v2/ecapi.consignee.setDefault', 'POST', {
		consignee: consignee
	})

export const consigneeGet = consignee =>
	fetchEndpoint('/v2/ecapi.default.address.get', 'POST', {})



// WEBPACK FOOTER //
// ./src/api/consignee.js